import store from '@/store/index.js';
import link from "@/scripts/host.js";
import loggedIn from '@/scripts/logged.js';


export default {
  name: 'List',
  props: ['options', 'empty', 'special'],
  data() {
    return {
      showPopUp: false,
      optionsArray: null,
      months: ['stycznia', 'lutego', 'marca', 'kwietnia', 'maja', 'czerwca', 'lipca',
      'sierpnia', 'września', 'października', 'listopada', 'grudnia'],
      selectedDate: null,
      defaultSelected: null,
      listDivide: null,
      listArray: null,
      firstElements: null,
      actualPlay: null,
      isPlaying: false,
      mainList: true,
      showlist: true,
      numberOfDownloads: 300,
      numberOfDownloadsNumberList: 20,
      menuShowInfo: false,
      newestDate: null,
      inputSearchStart: null,
      listMenu: true,
      // canVote: false
    }
  },
  methods: {
    togglePopUpVisibility() {
      this.showPopUp = !this.showPopUp;
    },
    getListDivide(id){
      this.axios(`https://lp3.polskieradio.pl/List/GetSongSelectionTypes?listId=${id}`).then((response)=>{
        this.listDivide = response.data;
      })
    },
    searchNewDate(value) {
      this.selectedDate = "" + value["day"] + " " + this.months[value["months"]] + " " + value["years"];
      let day = value["day"] >= 9 ? value["day"] : '0' + value["day"];
      let months = value["months"] >= 9 ? value["months"] : '0' + value["months"];
      let years = value["years"];
      let selectedDate = new Date(years, months, day);
      const firstDateLP3 = new Date(1982, 3, 24);
      const firstDateTop = new Date(1994, 11, 17);
      const firstDatePolskiTop = new Date(2008, 4, 3);
      if(selectedDate > this.newestDate) {
        day = this.newestDate.getDate() >= 9 ? this.newestDate.getDate() : '0' + this.newestDate.getDate();
        months = this.newestDate.getMonth() >= 9 ? this.newestDate.getMonth()+1 : '0' + (this.newestDate.getMonth()+1);
        years = this.newestDate.getFullYear();
      } else if (selectedDate < firstDateLP3 && this.options==='1') {
        day = firstDateLP3.getDate() >= 9 ? firstDateLP3.getDate() : '0' + firstDateLP3.getDate();
        months = firstDateLP3.getMonth() >= 9 ? firstDateLP3.getMonth()+1 : '0' + (firstDateLP3.getMonth()+1);
        years = firstDateLP3.getFullYear();
      } else if (selectedDate < firstDateTop && this.options==='2') {
        day = firstDateTop.getDate() >= 9 ? firstDateTop.getDate() : '0' + firstDateTop.getDate();
        months = firstDateTop.getMonth() >= 9 ? firstDateTop.getMonth()+1 : '0' + (firstDateTop.getMonth()+1);
        years = firstDateTop.getFullYear();
      } else if (selectedDate < firstDatePolskiTop && this.options==='3') {
        day = firstDatePolskiTop.getDate() >= 9 ? firstDatePolskiTop.getDate() : '0' + firstDatePolskiTop.getDate();
        months = firstDatePolskiTop.getMonth() >= 9 ? firstDatePolskiTop.getMonth()+1 : '0' + (firstDatePolskiTop.getMonth()+1);
        years = firstDatePolskiTop.getFullYear();
      } else {
        months = value["months"] >= 9 ? value["months"]+1 : '0' + (value["months"]+1);
      }
      let recquestValue = ""+ years + "-" + months + "-" + day + "";
      this.getListByDate(recquestValue);
    },
    getListByDate(value){
      this.axios.get(`${link.hostLink}List/GetListResultsByDate?typeId=${this.options}&date=${value}`).then((response)=>{
        // if(this.mainList){
        //   this.filterList(response.data.results);
        // }
        // let date = new Date(response.data.dateTo.split(" ")[0]);
        // this.selectedDate = "" + date.getDate() + " " + this.months[date.getMonth()] + " " + date.getFullYear();
        // this.getListDivide(response.data.id);
        this.defaultSelected = {
          'value':  response.data.id,
          'label': response.data.number,
          'listNumber': this.options
        }
        // store.dispatch('selectNote', this.defaultSelected);
        // if(this.options==='2'){
        //   store.dispatch('setTopNumber', this.defaultSelected.label);
        // } else if (this.options==='3'){
        //   store.dispatch('setPolskiTopWszech', this.defaultSelected.label);
        // }
        this.setDefaultselect(this.defaultSelected)
      })
    },
    playMP3(value){
      if(value !== '' && value !== this.actualPlay){
        this.actualPlay = value;
        this.isPlaying = true;
        this.$refs.audioPlayer.src = value;
        this.$refs.audioPlayer.play();
      } else if (value === this.actualPlay && !this.$refs.audioPlayer.paused) {
        this.$refs.audioPlayer.pause();
        this.isPlaying = false;
      } else if (value === this.actualPlay && this.$refs.audioPlayer.paused) {
        this.$refs.audioPlayer.play();
        this.isPlaying = true;
      }
      this.$refs.audioPlayer.addEventListener('ended', ()=>{
        this.actualPlay = null;
      })
    },
    async showToVoteList(){
      this.showlist = false;
      this.mainList = false;
      this.listMenu = false;
      this.numberOfDownloads = 300
      let token = await loggedIn();

      if(localStorage.user || sessionStorage.user) {
        this.axios({
          method: 'get',
          url: `${link.hostLink}SongList/GetSongsList?TypeId=${this.options}&PageSize=300&Skip=0`,
          headers: {authorization: `bearer ${token}`}
        }).then((response) => {
          this.filterList(response.data);
          this.showlist = true;
        })
      } else {
        this.axios.get(`${link.hostLink}SongList/GetSongsList?TypeId=${this.options}&PageSize=300&Skip=0`).then((response) => {
          this.filterList(response.data);
          this.showlist = true;
        })
      }
      if(this.options==="3") { //ustawianie ręczne baneru na 13
        store.dispatch('setPolskiTopWszech', "13");
      }
    },
    async infiniteHandler($state) {
      let token = await loggedIn();

      if(localStorage.user || sessionStorage.user) {
        this.axios({
          method: 'get',
          url: `${link.hostLink}SongList/GetSongsList?TypeId=${this.options}&PageSize=300&Skip=${this.downloads}`,
          headers: {authorization: `bearer ${token}`}
        }).then((response) => {
          if(response.data.length > 0) {
            this.listArray = [...this.listArray, ...response.data];
            this.numberOfDownloads += 300;
            $state.loaded();
          } else {
            $state.complete();
          }
        })
      } else {
        this.axios.get(`${link.hostLink}SongList/GetSongsList?TypeId=${this.options}&PageSize=300&Skip=${this.downloads}`).then((response) => {
          if(response.data.length > 0) {
            this.listArray = [...this.listArray, ...response.data];
            this.numberOfDownloads += 300;
            $state.loaded();
          } else {
            $state.complete();
          }
        })
      }
    },
    infiniteDownloadList($state){
      this.axios.get(`${link.hostLink}List/GetLists?TypeId=${this.options}&PageSize=300&Skip=${this.numberOfDownloadsNumberList}`).then((response)=>{
        if(response.data.data.length > 0) {
          let newList = response.data.data.map((value)=>{
            let arItem = {
              'label': parseInt(value.number),
              'value': value.id
            }
            return arItem
          });
          this.optionsArray = [...this.optionsArray, ...newList];
          this.numberOfDownloadsNumberList += 20;
          $state.loaded();
        } else {
          $state.complete();
        }
      });
    },
    getActualList() {
      this.showlist = false;
      this.axios.get(`${link.hostLink}List/GetCurrentListResults?typeId=${this.options}`).then((response) => {
        let date = new Date(response.data.dateTo.split(" ")[0]);
        this.selectedDate = "" + date.getDate() + " " + this.months[date.getMonth()] + " " + date.getFullYear();
        this.newestDate = date;
        if (!this.$route.params.id) {
          this.filterList(response.data.results);
          if(this.$route.path === '/polskitopwszechczasow') {
            this.showToVoteList();
          } else {
            this.showlist = true;
            this.mainList = true;
          }
        }
      })
    },
    getAllIdList(){
      if(this.options !== "11"){
        this.axios.get(`${link.hostLink}List/GetLists?TypeId=${this.options}&PageSize=300&Skip=0`).then((response)=>{
          this.optionsArray = response.data.data.map((value)=>{
            let arItem = {
              'label': parseInt(value.number),
              'value': value.id
            }
            return arItem
          });
          if(this.$route.params.id){
            this.defaultSelected = {
              'value': parseInt(this.$route.params.id),
              'label': this.$route.query.name,
              'listNumber': this.options
            }
            // store.dispatch('selectNote', this.defaultSelected);
            // this.getListDivide(this.$route.params.id);
            // this.getListById();
            this.searchForNote(this.$route.params.id)
            this.getActualList();
          } else if (this.eyrlierSelectedNote && parseInt(this.eyrlierSelectedNote.label) <= parseInt(this.optionsArray[0].label) && this.eyrlierSelectedNote.listNumber === this.options) {
            this.defaultSelected = this.eyrlierSelectedNote;
            this.defaultSelected.listNumber = this.options;
            this.getListDivide(this.eyrlierSelectedNote.value);
            this.getListById();
          } else {
            this.getActualList();
            this.defaultSelected = this.optionsArray[0];
            this.defaultSelected.listNumber = this.options;
            store.dispatch('selectNote', this.defaultSelected);
            this.getListDivide(this.defaultSelected.value);
          }
          if(this.options==='2'){
            store.dispatch('setTopNumber', this.defaultSelected.label);
          } else if (this.options==='3'){
            store.dispatch('setPolskiTopWszech', this.defaultSelected.label);
          }
          if(!this.mainList){
            this.backToList();
          }
        })
      } else {
    
        if (/^[-+]?[0-9]+$/.test(this.$route.params.top)) {
          this.axios.get(`${link.hostLink}List/GetListResults?listId=${this.$route.params.top}`).then((response)=>{
            this.defaultSelected = {
              'value': response.data.id,
              'label': response.data.number,
              'listNumber': this.options
            }
            this.filterList(response.data.results);
            // this.showlist = true;
          })
        } else {
          this.axios.post(`${link.hostLink}List/Search`, {
            "pageSize": 1,
            "searchValue": `${this.$route.params.top}`,
            "searchType": 1,
            "skip": 0
          })
         .then((response)=>{
                let listId = response.data.data[0].id;
                this.axios.get(`${link.hostLink}List/GetListResults?listId=${listId}`).then((response)=>{
                  this.defaultSelected = {
                    'value': response.data.id,
                    'label': response.data.number,
                    'listNumber': this.options
                  }
                  this.filterList(response.data.results);
                  // this.showlist = true;
                })
                
          })
          
      }
    }
    },
    getListById(){
      if(this.mainList) {
        this.showlist = false;
        this.axios.get(`${link.hostLink}List/GetListResults?listId=${this.defaultSelected.value}`).then((response)=>{
          this.getListDivide(this.defaultSelected.value);
          this.filterList(response.data.results);
          this.defaultSelected = {
            'value': response.data.id,
            'label': response.data.number,
            'listNumber': this.options
          }
          let date = new Date(response.data.dateTo.split(" ")[0]);
          this.selectedDate = "" + date.getDate() + " " + this.months[date.getMonth()] + " " + date.getFullYear();
          if(this.options==='2'){
            store.dispatch('setTopNumber', this.defaultSelected.label);
          } else if (this.options==='3'){
            store.dispatch('setPolskiTopWszech', this.defaultSelected.label);
          }
          self.showlist = true;
        })
      }
    },
    backToList() {
      this.showlist = false;
      this.listMenu = true;

      this.listArray = [];
      if(!this.special && this.defaultSelected && this.defaultSelected.value === this.optionsArray[0].id ) {
        this.getListDivide(this.defaultSelected.value);
        this.mainList = true;
        this.getActualList();
      } else if (!this.special){
        this.mainList = true;
        this.getListById();
        this.getListDivide(this.defaultSelected.value);
      }
      this.showlist = true;
    },
    checkIf26ItIS() {
      const actualDate = new Date();
      const testDate = new Date("2020-01-01 22:00");
      if (actualDate > testDate) {
        return true;
      } else {
        return false;
      }
    },
    setDefaultselect(def) {
      // this.defaultSelected = def;
      // this.defaultSelected.listNumber = this.options;
      // store.dispatch('selectNote', this.defaultSelected);
      // this.getListById();
      // this.getListDivide(this.defaultSelected.value);
      if(this.inputSearchStart) {
        const self = this;
        clearInterval(self.inputSearchStart);
        self.inputSearchStart = setTimeout(()=>{
          if (this.options==='2') {
            this.$router.push(`/topwszechczasow/${def.label}`)
          } else if (this.options==='3') {
            this.$router.push(`/polskitopwszechczasow/${def.label}`)
          } else {
            this.$router.push(`/lp3/${def.label}`)
          }
        }, 700);
      } else {
        const self = this;
        self.inputSearchStart = setTimeout(()=>{
          if (this.options==='2') {
            this.$router.push(`/topwszechczasow/${def.label}`)
          } else if (this.options==='3') {
            this.$router.push(`/polskitopwszechczasow/${def.label}`)
          } else {
            this.$router.push(`/lp3/${def.label}`)
          }
        }, 700);
      }
    },
    toggleMenuShowInfo(){
      this.menuShowInfo = !this.menuShowInfo;
    },
    closeMenuInfoBar(){
      this.menuShowInfo = false;
    },
    searchForNote(label){
      if(this.inputSearchStart) {
        const self = this;
        clearInterval(self.inputSearchStart);
        self.inputSearchStart = setTimeout(()=>{
          self.showlist = false;
          self.axios.get(`${link.hostLink}List/GetLists?TypeId=${self.options}&SearchValue=${label}`).then((response)=>{
            self.found = false;
            response.data.data.forEach((item) => {
              if(label === item.number) {
                self.defaultSelected = {
                  'value': item.id,
                  'label': item.number,
                  'listNumber': this.options
                 
                }
                self.defaultSelected.listNumber = self.options;
                store.dispatch('selectNote', self.defaultSelected);
                self.getListById();
                self.showlist = true;
                self.found = true;
              }
            });
            if (!self.found) {
              
              response.data.data.filter(x => x.number.match(/-/)).forEach((item) => {
                let numArr = item.number.split('-');
                if(label === numArr[0] || label === numArr[1]) {
                  self.defaultSelected = {
                    'value': item.id,
                    'label': item.number,
                    'listNumber': this.options
                   }

                   
                  self.defaultSelected.listNumber = self.options;
                  store.dispatch('selectNote', self.defaultSelected);
                  self.getListById();
                  self.showlist = true;
                  self.found = true;
                }
              });
            }
          })
        }, 700);
      } else {
        const self = this;
        self.inputSearchStart = setTimeout(()=>{
          self.axios.get(`${link.hostLink}List/GetLists?TypeId=${self.options}&SearchValue=${label}`).then((response)=>{

            response.data.data.forEach((item) => {
              if(label === item.number) {
                self.defaultSelected = {
                  'value': item.id,
                  'label': item.number,
                  'listNumber': this.options
                }
                self.defaultSelected.listNumber = self.options;
                store.dispatch('selectNote', self.defaultSelected);
                self.getListById();
                self.showlist = true;
              }
            });
          })
        }, 700);
      }
    },
    showVoteList(){
      if(this.options !== "1"){
        if(!this.canVote){
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    filterList(list){
      if(this.mainList){
        this.listArray = list.filter((value)=>{
          if(value.position > 1){
            return value
          }
        });
        this.firstElements = list.filter((value)=>{
          if(value.position <= 1){
            return value
          }
        });
      } else {
        this.listArray = list;
        this.firstElements = null;
      }
    }
  },
  computed: {
    selDate() {
      return this.selectedDate;
    },
    weekElement(){
      if(this.options === '1'){
        return "Tygodnie";
      } else {
        return "Na liście";
      }
    },
    isWeekly(){
      if(this.options === '1'){
        return "Tydzień w zestawieniu";
      } else {
        return "W zestawieniu";
      }
    },
    downloads() {
      return this.numberOfDownloads;
    },
    haveTop() {
      return this.$route.params.top;
    },
    logYourSelf() {
      return this.$store.state.loggedIn;
    },
    htmlPathId() {
      return this.$route.params.id;
    },
    optionsForLists() {
      return this.optionsArray;
    },
    eyrlierSelectedNote() {
      return store.state.selectedNote;
    },
    listWithout1place() {
      return this.listArray;
    },
    firstPlace() {
      return this.firstElements;
    }
  },
  watch: {
    haveTop(){
      this.axios.get(`${link.hostLink}List/GetListResults?listId=${this.$route.params.top}`).then((response)=>{
        this.listArray = response.data.results;
      })
      this.getAllIdList();
    },
    logYourSelf() {
      this.backToList();
    },
    htmlPathId() {
      this.getAllIdList();
    }
  },
  mounted() {
      this.axios.get(`${link.hostLink}SongList/GetVotingInfo?typeId=${this.options}`).then((response)=>{
        this.canVote = response.data.isVotingActive;
      })
      this.getAllIdList();
  }
}
